var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HelpTip',_vm._b({},'HelpTip',_vm.labelInfo,false)),_c('van-field',{staticClass:"input work-temp-form-item",attrs:{"name":_vm.id,"clearable":true,"rules":[
      {
        required: _vm.required,
        message: ((_vm.languages.smartOrderPleaseInpt) + " " + _vm.label)
      }
    ],"placeholder":_vm.placeholder || '',"maxlength":"600"},on:{"input":_vm.checkWordLimit},model:{value:(_vm.formData[_vm.id]),callback:function ($$v) {_vm.$set(_vm.formData, _vm.id, $$v)},expression:"formData[id]"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }